import { TFunction } from "i18next";

import { IBulkActionItem } from "@ryde/controls";

import {
  RIDE_BULK_ACTION_META,
  TRideBulkActionKey,
} from "./bulk-operations.rides.constants";

export const buildRideBulkAction = ({
  key,
  t,
  onClick,
  isHidden,
}: {
  key: TRideBulkActionKey;
  t: TFunction;
  onClick: () => void;
  isHidden?: boolean;
}): IBulkActionItem => {
  const { labelKey, hintKey, icon, permission } = RIDE_BULK_ACTION_META[key];

  return {
    key,
    label: t(labelKey),
    hint: t(hintKey),
    icon,
    permission,
    onClick,
    isHidden,
  };
};
